import React, { useEffect, useState } from "react"

import {
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  CardHeader,
  Avatar,
  Box,
  IconButton
} from "@material-ui/core"
// import MoreVertIcon from "@material-ui/icons/MoreVert"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"
import { useLocation } from "react-router-dom"
import cloudinary from "cloudinary-core"
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos"
import { useHistory } from "react-router-dom"

const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})

const Post = ({ classes }) => {
  const history = useHistory()

  const location = useLocation()
  const {
    created,
    first_name: firstName,
    last_name: lastName,
    body,
    image,
    posted,
    // title_value,
    titleValue,
    profile_image: profileImage
  } = location.state.post

  const timeLeft = () => {
    const dateCreated = new Date(created)
    const now = new Date()
    const hours = Math.abs(now - dateCreated) / 36e5
    const timeLeft = posted
      ? 366 - Math.ceil(hours / 24)
      : 8 - Math.ceil(hours / 24)
    let expiresDisplay

    switch (true) {
      case timeLeft > 1:
        expiresDisplay = `${timeLeft} days`
        break
      case timeLeft === 1:
        expiresDisplay = `${timeLeft} day`
        break
      case timeLeft < 1:
        expiresDisplay = `Today`
        break
    }

    return expiresDisplay
  }

  const [uploadType, setUploadType] = useState(null)
  const [source, setSource] = useState(null)

  useEffect(() => {
    const fileObj = JSON.parse(image)
    setUploadType(fileObj.resource_type)
    // setTimeout(() => {
    if (fileObj.resource_type === "video") {
      setSource(cl.video_url(fileObj.public_id, { quality: 60 }))
    } else {
      setSource(
        cl.url(fileObj.public_id, {
          width: 600,
          height: 600,
          crop: "fill",
          gravity: "auto"
        })
      )
    }
    // }, 2000)
  }, [image])
  return (
    <Container className={classes.container}>
      <Box className={classes.topBar}>
        <IconButton className={classes.iconButton}>
          <ArrowBackIosIcon
            onClick={() => {
              history.goBack()
            }}
            className={classes.backIcon}
          />
        </IconButton>
      </Box>
      <Grid container direction="row" justify="flex-start">
        <Card className={classes.root}>
          {uploadType && (
            <CardMedia
              className={uploadType === "image" ? classes.image : classes.video}
              component={uploadType === "video" ? "video" : "img"}
              controls={uploadType === "video"}
              src={`${source}#t=0.1`}
              title=""
              preload="metadata"
            />
          )}
          {/* <IconButton className={classes.settings} aria-label="settings">
              <MoreVertIcon />
            </IconButton> */}
          <CardHeader
            className={classes.header}
            avatar={
              <Avatar
                aria-label="Profile"
                className={classes.avatar}
                src={
                  profileImage &&
                  cl.url(JSON.parse(profileImage).public_id, {
                    width: 100,
                    crop: "scale"
                  })
                }
              >
                {firstName.split("").splice(0, 1)}
              </Avatar>
            }
            classes={{
              action: classes.cardHeaderAction
            }}
            action={<Typography>expires in {timeLeft()}</Typography>}
            title={`${firstName} ${lastName}`}
            subheader={titleValue ? titleValue : ""}
          />
          <CardContent className={classes.content}>
            <Typography className={classes.body} variant="body1" component="p">
              {body}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Container>
  )
}

export default withStyles(styles)(Post)



// WEBPACK FOOTER //
// ./src/pages/App/Post/index.js